import React from 'react'
import { Grid, Segment, Message, Embed } from 'semantic-ui-react'
import { findIndex } from 'lodash'

import fire from '../components/App/fire';

const Explorer = () => {
  let urls

  fire
    .database()
    .ref('endpoints')
    .orderByKey()
    .on('value', snapshot => {
      urls = snapshot.val()
    })

  if (!urls) {
    return (
      <Grid columns="equal">
        <Grid.Column>
          <Segment loading style={{ minHeight: 100, marginBottom: 20 }} basic />
        </Grid.Column>
      </Grid>
    )
  }

  const index = findIndex(urls, endpoint => endpoint.active)
  return (
    <Grid columns="equal">
      <Grid.Column>
        <Message>
          <Message.Header>How to use the GraphQL Playground</Message.Header>
          <Message.List>
            <Message.Item>IMPORTANT: The authorization token is required in the HTTP Headers tab for the Explorer to work.</Message.Item>
            <Message.Item>Enter the query you want to explore in the Query Editor and the corresponding query variables (if necessary) in the Query Variables tab.</Message.Item>
            <Message.Item>Click the play button to run the query and start exploring. Have fun!</Message.Item>
          </Message.List>
        </Message>
        <Segment style={{ /* height: "900px",  */ marginBottom: "40px" }} >
          <Embed
            active
            url={urls[index].url}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  )
}

export default Explorer
